import React, { useEffect, useState } from 'react';
import Status from '../../../components/Status';

const ShipStabilization = ({ dataSource }) => {

    const [valueData1, setValueData1] = useState(0);
    const [valueData2, setValueData2] = useState(0);
    const [data, setData] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                // const response = dataSource.filter((item) => item.DisplayNo === 7);
                const convertValue1 = dataSource
                    ? Number(parseFloat(dataSource.Value2 || 0).toFixed(1))
                    : 0;
                const convertValue2 = dataSource
                    ? Number(parseFloat(dataSource.Value1 || 0).toFixed(1))
                    : 0;
                setValueData1(convertValue1);
                setValueData2(convertValue2);
                setData([dataSource]);
            } catch (error) {
                console.log(error);
            }
        }

        if (dataSource) {
            fetchData();
        }

    }, [dataSource]);

    const shipRotationStyle1 = {
        transform: `rotate(${valueData1}deg)`,
        transition: 'transform 0.75s ease'
    };

    const shipRotationStyle2 = {
        transform: `rotate(${valueData2}deg)`,
        transition: 'transform 0.75s ease'
    };

    // Determine status color based on angle values
    const getStatusColor = (value) => {
        const absValue = Math.abs(value);
        if (absValue <= 5) return 'text-green-500';
        if (absValue <= 15) return 'text-yellow-500';
        return 'text-red-500';
    };

    const getStatusBg = (value) => {
        const absValue = Math.abs(value);
        if (absValue <= 5) return 'bg-green-50 border-green-200';
        if (absValue <= 15) return 'bg-yellow-50 border-yellow-200';
        return 'bg-red-50 border-red-200';
    };

    return (
        <div className="w-full space-y-6">
            {/* Main Content */}
            <div className="flex flex-col xl:flex-row justify-evenly items-center gap-8 w-full">
                {/* Pitch Axis */}
                <div className="relative group w-full">
                    <div className="relative flex flex-col justify-center items-center w-full gap-2">
                        <Status setData={data} />

                        {/* Axis Label */}
                        {/* <h3 className="text-lg font-semibold text-gray-700 mb-8">X-Axis</h3> */}

                        {/* Compass Circle */}
                        <div className="relative w-[200px] h-[200px] mb-4">
                            {/* Outer Ring */}
                            <div className="absolute inset-0 rounded-full border-4 border-gray-300 shadow-inner bg-gradient-to-b from-gray-50 to-gray-100"></div>

                            {/* Degree Markings */}
                            <div className="absolute inset-2 rounded-full border-2 border-gray-400"></div>

                            {/* Center Cross */}
                            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-1 h-8 bg-gray-400"></div>
                            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-8 h-1 bg-gray-400"></div>

                            {/* Rotating Ship Container */}
                            <div className="relative w-full h-full flex items-center justify-center" style={shipRotationStyle1}>
                                {/* Water Level */}
                                <div className="absolute bottom-0 w-full h-1/2 bg-gradient-to-t from-blue-900 to-blue-600 rounded-b-full opacity-80"></div>

                                {/* Ship Image */}
                                <img
                                    src="/assets/ship.png"
                                    alt="ship pitch"
                                    className="relative mb-12 w-16 h-16 z-10 drop-shadow-lg transition-transform duration-300 group-hover:scale-110"
                                />

                                {/* Horizon Line */}
                                <div className="absolute top-1/2 left-0 right-0 h-0.5 bg-gray-400 opacity-60"></div>
                            </div>

                            {/* Degree Display */}
                            <div className="absolute -top-2 left-1/2 transform -translate-x-1/2">
                                <div className={`px-4 py-2 rounded-full shadow-lg ${getStatusBg(valueData1)}`}>
                                    <span className={`text-2xl font-bold ${getStatusColor(valueData1)}`}>
                                        {valueData1}°
                                    </span>
                                </div>
                            </div>
                        </div>

                        {/* Status Indicator */}
                        {/* <div className="flex items-center gap-2 text-sm">
                            <div className={`w-3 h-3 rounded-full ${Math.abs(valueData1) <= 5 ? 'bg-green-500' : Math.abs(valueData1) <= 15 ? 'bg-yellow-500' : 'bg-red-500'}`}></div>
                            <span className={`font-medium ${getStatusColor(valueData1)}`}>
                                {Math.abs(valueData1) <= 5 ? 'Stable' : Math.abs(valueData1) <= 15 ? 'Moderate' : 'Unstable'}
                            </span>
                        </div> */}
                    </div>
                </div>

                {/* Roll Axis */}
                <div className="relative group w-full">
                    <div className="relative flex flex-col justify-center items-center w-full gap-2">
                        <Status setData={data} />

                        {/* Axis Label */}
                        {/* <h3 className="text-lg font-semibold text-gray-700 mb-8">Y-Axis</h3> */}

                        {/* Compass Circle */}
                        <div className="relative w-[200px] h-[200px] mb-4">
                            {/* Outer Ring */}
                            <div className="absolute inset-0 rounded-full border-4 border-gray-300 shadow-inner bg-gradient-to-b from-gray-50 to-gray-100"></div>

                            {/* Degree Markings */}
                            <div className="absolute inset-2 rounded-full border-2 border-gray-400"></div>

                            {/* Center Cross */}
                            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-1 h-8 bg-gray-400"></div>
                            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-8 h-1 bg-gray-400"></div>

                            {/* Rotating Ship Container */}
                            <div className="relative w-full h-full flex items-center justify-center" style={shipRotationStyle2}>
                                {/* Water Level */}
                                <div className="absolute bottom-0 w-full h-1/2 bg-gradient-to-t from-blue-900 to-blue-600 rounded-b-full opacity-80"></div>

                                {/* Ship Image */}
                                <img
                                    src="/assets/ship-x.png"
                                    alt="ship roll"
                                    className="relative mb-12 w-32 h-auto z-10 drop-shadow-lg transition-transform duration-300 group-hover:scale-110"
                                />

                                {/* Horizon Line */}
                                <div className="absolute top-1/2 left-0 right-0 h-0.5 bg-gray-400 opacity-60"></div>
                            </div>

                            {/* Degree Display */}
                            <div className="absolute -top-2 left-1/2 transform -translate-x-1/2">
                                <div className={`px-4 py-2 rounded-full shadow-lg ${getStatusBg(valueData2)}`}>
                                    <span className={`text-2xl font-bold ${getStatusColor(valueData2)}`}>
                                        {valueData2}°
                                    </span>
                                </div>
                            </div>
                        </div>

                        {/* Status Indicator */}
                        {/* <div className="flex items-center gap-2 text-sm">
                            <div className={`w-3 h-3 rounded-full ${Math.abs(valueData2) <= 5 ? 'bg-green-500' : Math.abs(valueData2) <= 15 ? 'bg-yellow-500' : 'bg-red-500'}`}></div>
                            <span className={`font-medium ${getStatusColor(valueData2)}`}>
                                {Math.abs(valueData2) <= 5 ? 'Stable' : Math.abs(valueData2) <= 15 ? 'Moderate' : 'Unstable'}
                            </span>
                        </div> */}
                    </div>
                </div>
            </div>

            {/* Legend */}
            {/* <div className="mt-8 flex justify-center">
                <div className="flex items-center gap-6 bg-white rounded-lg shadow-md p-4 border">
                    <div className="flex items-center gap-2">
                        <div className="w-3 h-3 rounded-full bg-green-500"></div>
                        <span className="text-sm text-gray-600">Stable (0° - 5°)</span>
                    </div>
                    <div className="flex items-center gap-2">
                        <div className="w-3 h-3 rounded-full bg-yellow-500"></div>
                        <span className="text-sm text-gray-600">Moderate (5° - 15°)</span>
                    </div>
                    <div className="flex items-center gap-2">
                        <div className="w-3 h-3 rounded-full bg-red-500"></div>
                        <span className="text-sm text-gray-600">Unstable (&gt;15°)</span>
                    </div>
                </div>
            </div> */}
        </div>
    );
}

export default ShipStabilization;
